import { dataIsArray, dataIsObject } from "./is";
/* take an object and returns typed keys list  */
export const dataObjectKeys = (object) => Object.keys(object);
/* take two objects and returns true if they are deep equivalent */
export const dataObjectsDeepEqual = (object1, object2, excludedKeys) => {
    const keys1 = dataObjectKeys(object1).filter((key) => typeof object1[key] !== "undefined" &&
        !(excludedKeys === null || excludedKeys === void 0 ? void 0 : excludedKeys.includes(key.toString())));
    const keys2 = dataObjectKeys(object2).filter((key) => typeof object2[key] !== "undefined" &&
        !(excludedKeys === null || excludedKeys === void 0 ? void 0 : excludedKeys.includes(key.toString())));
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (let key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = dataIsObject(val1) && dataIsObject(val2);
        if ((areObjects && !dataObjectsDeepEqual(val1, val2, excludedKeys)) ||
            (!areObjects && val1 !== val2)) {
            return false;
        }
    }
    return true;
};
export const dataObjectsOneStageObject = (anyObject, prefix = "") => dataObjectKeys(anyObject).reduce((previousObjectValue, currentKey) => {
    const currentValue = anyObject[currentKey];
    if (dataIsObject(currentValue) && !dataIsArray(currentValue)) {
        previousObjectValue = Object.assign(Object.assign({}, previousObjectValue), dataObjectsOneStageObject(currentValue, prefix + `${currentKey}__`));
    }
    else {
        previousObjectValue[prefix + currentKey] = dataIsArray(currentValue)
            ? currentValue.join(",")
            : currentValue;
    }
    return previousObjectValue;
}, {});
export const dataObjectRemoveUndefinedValues = (obj) => {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }
    const filteredObj = {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
            const value = obj[key];
            filteredObj[key] =
                value instanceof Date || Array.isArray(value)
                    ? value
                    : dataObjectRemoveUndefinedValues(value);
        }
    }
    return filteredObj;
};
//# sourceMappingURL=object.js.map